import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  token: string;
};

export const sendNewPasswordConfirmToken = async (params: Params) => {
  const fetchURL = getM8AuthURL('sendNewPasswordConfirmToken');

  const body = new FormData();
  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
